"use client";
import Button from "../../../../shared/components/ui/Button";
import EditProgramStudentFormFull from "./EditProgramStudentFormFull";
import useProgramStudent from "../../../academyProgramDetail/hooks/students/useProgramStudent";
import useUpdateProgramStudent from "../../../academyProgramDetail/hooks/students/useUpdateProgramStudent";
import React from "react";

export default function EditProgramStudent({
  setOpenModal,
  programStudentId,
  onSuccess,
}: {
  setOpenModal: (val: boolean) => void;
  programStudentId: number;
  onSuccess?: () => void;
}) {
  const { programStudentData, getProgramStudentById } = useProgramStudent({});
  React.useEffect(() => {
    getProgramStudentById(programStudentId);
  }, [programStudentId]);
  const { control, handleSubmit, loading } = useUpdateProgramStudent({
    programStudent: programStudentData!,
    setOpenModal,
    onSuccess,
  });

  if (!programStudentData?.user) {
    return null;
  }

  return (
    <form onSubmit={handleSubmit}>
      <EditProgramStudentFormFull control={control} />
      <div className="mt-4 flex items-center justify-end">
        <Button primary className="bg-[#072082]" type="submit" variant="filled">
          <i className="fa-regular fa-floppy-disk" /> Actualizar
        </Button>
      </div>
    </form>
  );
}
